import { Injectable } from '@angular/core';

import { HttpService } from '@bbraun/helpex/src/lib/http';
import { environment } from '@environment/environment';
import { Page } from '@shared/interfaces/pagination/page.interface';
import { Paging } from '@shared/interfaces/pagination/paging.interface';
import { forkJoin, Observable } from 'rxjs';

import { ROUTES } from '../../constants/routes/routes.constants';
import { HttpParamsFactory } from '../../factory/http-params/http-params.factory';
import { Article } from '../../interfaces/article/article.interface';
import { Combination } from '../../interfaces/combination/combination.interface';
import {
  CombinationFilter,
  CombinationFilterValues
} from '../../interfaces/combination/combination-filters/combination-filters.interface';
import { CombinationWithVariants } from '../../interfaces/combination/combination-with-variants/combination-with-variants.interface';

@Injectable({ providedIn: 'root' })
export class HomeService {
  constructor(private readonly httpService: HttpService) {}

  getCombinationsWithFilters(
    options: CombinationFilter,
    paging: Paging
  ): Observable<[Page<Combination>, CombinationFilterValues]> {
    const paramsFilters = new HttpParamsFactory(options).returnParams();
    const paramsCombinations = new HttpParamsFactory({ ...options, ...paging }).returnParams();
    return forkJoin([
      this.httpService
        .request(ROUTES.COMBINATIONS)
        .params(paramsCombinations)
        .get(environment.backendUrl),
      this.httpService.request(ROUTES.FILTERS).params(paramsFilters).get(environment.backendUrl)
    ]);
  }

  getCombinationWithVariants(id: string): Observable<CombinationWithVariants> {
    return this.httpService.request(`${ROUTES.COMBINATIONS}/${id}`).get(environment.backendUrl);
  }

  getCombinationArticles(variantId: string): Observable<Array<Article>> {
    return this.httpService
      .request(`${ROUTES.VARIANTS}/${variantId}/${ROUTES.ARTICLES}`)
      .get(environment.backendUrl);
  }

  getFilters(options?: CombinationFilter): Observable<CombinationFilterValues> {
    const params = new HttpParamsFactory(options).returnParams();
    return this.httpService.request(ROUTES.FILTERS).params(params).get(environment.backendUrl);
  }
}
